// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const VisibleSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M128 54.7c-7.6.9-26.8 5.6-34.9 8.5-33.3 11.7-64.5 36.2-83.3 65.2L6 134.3v31.4l3.8 5.9c15.1 23.2 38.9 44.2 64.7 57.2C87 235 98.3 239 113.6 242.6c11.4 2.7 13 2.9 36.4 2.9s25-.2 36.4-2.9c15.3-3.6 26.6-7.6 39.1-13.8 25.8-13 49.6-34 64.7-57.2l3.8-5.9v-31.4l-3.8-5.9c-8.1-12.5-21.2-27-33.2-36.8-20.5-16.8-43.5-27.9-70.6-34.2-10.8-2.5-14-2.8-33.4-3-11.8-.1-23.1 0-25 .3zm52 18.8c31.7 7.1 56.3 20.7 78.3 43.2 4.3 4.4 10.5 11.7 13.8 16.2l5.9 8.3v17.6l-5.9 8.3c-23.4 32.6-61.1 55.2-101.9 61-11 1.5-40.2.6-50.2-1.6-19.3-4.2-38.7-12.4-54.8-23.2-10.6-7-30.9-26.9-38.1-37.2l-5.1-7.4v-17.5l5.9-8.3c11.3-15.8 28.4-31.3 45.4-41.3 18-10.5 31.9-15.3 57.7-20 6.2-1.1 41.7.3 49 1.9z" />
      <path d="M135 95.4c-19.8 5.7-35.1 21.4-39.9 41.1-1.6 6.4-1.6 20.6 0 27 5 20.5 21.7 37 42 41.5 8.2 1.8 24.9.9 32.4-1.8 15.4-5.6 29.1-19.6 34.1-34.8 2.7-8.3 2.7-28.5 0-36.8-5-15.2-18.6-29.1-34.1-34.8-7.4-2.7-27.3-3.5-34.5-1.4zm31.3 18.9c7.4 3.4 16 11.9 19.5 19.4 2.4 5.2 2.7 7 2.7 16.3s-.3 11.1-2.7 16.3c-3.5 7.4-12.1 16-19.5 19.5-5.2 2.4-7 2.7-16.3 2.7s-11.1-.3-16.3-2.7c-7.4-3.5-16-12.1-19.5-19.5-2.4-5.2-2.7-7-2.7-16.3s.3-11.1 2.6-16c4.8-10.1 13-17.6 23.2-21.2 7.8-2.8 21.3-2.1 29 1.5z" />
    </svg>
  )
}
